<script setup>
import { storeToRefs } from 'pinia';

import { Wrench } from 'lucide-vue-next';

import Logo from '@/components/ui/logo/Logo.vue';
import { useMaintenanceStore } from '@/stores/maintenance';

const { isMaintenanceActive } = storeToRefs(useMaintenanceStore());
</script>

<template>
  <div
    v-if="isMaintenanceActive"
    class="maintenance-overlay"
  >
    <Logo class="maintenance-overlay-logo" />
    <h1 class="maintenance-overlay-title">
      {{ $t('Scheduled maintenance in progress') }}
    </h1>
    <p class="maintenance-overlay-text">
      {{ $t('We are updating the platform. This may take some time — please check back soon.') }}
    </p>
    <div class="maintenance-overlay-icon">
      <Wrench :size="36" />
    </div>
  </div>
</template>

<style scoped>
.maintenance-overlay {
  position: fixed;
  inset: 0;
  /* Above Preloader (9999999) and every dialog/popover layer */
  z-index: 10000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px;
  background: var(--wp-surface-default);
  color: var(--wp-text-primary);
  font-family: var(--wp-font-sans);
  text-align: center;
}

.maintenance-overlay-logo {
  margin-bottom: 16px;
  width: auto;
}

/* Logo's SVG has fixed width/height attributes (175x30) — scale it here */
.maintenance-overlay-logo :deep(svg) {
  width: 280px;
  height: 48px;
}

.maintenance-overlay-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: var(--wp-surface-secondary);
  color: var(--wp-text-accent);
}

.maintenance-overlay-title {
  margin: 8px 0 0;
  font-size: 1.375rem;
  font-weight: 600;
}

.maintenance-overlay-text {
  max-width: 420px;
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--wp-text-secondary);
}
</style>
